import { useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import CouponListQuery from './gql/CouponListQuery.gql'

export default function useCouponList (broadcastId: string) {
  const query = useLazyQuery(CouponListQuery, {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
    variables: { broadcastId }
  })
  const [queryCouponList] = query

  useEffect(() => {
    if (!broadcastId) return
    queryCouponList()
  }, [broadcastId, queryCouponList])

  return query
}
